import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StockService } from '../../home/services/stocks.service';


@Component({
  selector: 'app-products-list-modal',
  templateUrl: './products-list-modal.component.html',
  styleUrls: ['./products-list-modal.component.scss']
})
export class ProductsListModalComponent implements OnInit {

    public productlist: any;

    datasource: null;
    pageIndex: number;
    pageSize: number;
    length: number;
    p = 1;
  // tslint:disable-next-line:variable-name
    total_count: number;
  // tslint:disable-next-line:variable-name
    current_page: number;
    e = 1; any;

    pageEvent: PageEvent;
    public showDataTable: any;
    public activePageDataChunk = [];

    public selectedProductIndex = 0;

    constructor(public stockservice: StockService, public dialog: MatDialog, public dialogRef: MatDialogRef<ProductsListModalComponent>) { }

    ngOnInit() {
      this.getProductsData(this.e);
    }

    getProductsData(e) {
      const page = e;
      this.stockservice.getProducts(e).subscribe(res => {
        // @ts-ignore
        this.productlist = res.data.items;
        // @ts-ignore
        this.total_count = res.data.total;
        // @ts-ignore
        this.pageIndex = res.data.current_page;
        this.pageSize = 10;
        this.length = 20;
        // console.log('products data', this.productlist);
        this.current_page = this.pageIndex;
        // this.onPageChange(this.e)
      });
    }

    editTable(id, e) {
      // console.log( e, 'see');
    }

    selectRow(index: any) {
      this.selectedProductIndex = index;
    }

    close() {
      this.dialogRef.close();
    }

  // tslint:disable-next-line:variable-name
    confirm(product_index: any) {
      // selected product submission
      const selectedproduct: any = this.productlist[product_index];
      this.dialogRef.close();
    }
}
